import EditButton from 'components/FrictionlessCheckout/Payment/PaymentMethodList/CreditCardsList/EditButton/EditButton';

export default EditButton;
